import { render, staticRenderFns } from "./TabelaClassificadosEdital.vue?vue&type=template&id=05457d3e"
import script from "./TabelaClassificadosEdital.vue?vue&type=script&lang=ts"
export * from "./TabelaClassificadosEdital.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports